export default "__VITE_ASSET__DETiYQ77__"